import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Dashboard from './Dashboard';
import Graph from './Graph';  // You'll need to create this component
import BacktestingDashboard from './BacktestingDashboard';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/graph/:symbol" element={<Graph />} />
          <Route path="/backtest" element={<BacktestingDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;